import { Epic, StateObservable, ofType } from 'redux-observable';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Observable, catchError, concatMap, from, mergeMap, of } from 'rxjs';
import { ToastNotification } from '@scenario/models/toast-notification.model';
import { HourlyDataRequest } from '@scenario/models/hourly-data-request.model';
import { displayToast } from '@store/toast-notifications/toast-notifications-slice';
import {
  requestHourlyDataFailure,
  requestHourlyDataSuccess,
} from '@store/scenario/hourly-data-request/hourly-data-request-slice';

export const requestHourlyDataEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('hourly-data-request/requestHourlyData'),
    concatMap((action: PayloadAction<HourlyDataRequest>) =>
      from(dependencies.hourlyDataRequestGateway.request(action.payload)).pipe(
        mergeMap(() => {
          const toastNotification: ToastNotification = {
            title: 'Hourly Data Request',
            content: 'Your hourly data request has been sent successfully',
            status: 'info',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          return of(requestHourlyDataSuccess(), displayToast(toastNotification));
        }),
        catchError(() => {
          const toastNotification: ToastNotification = {
            title: 'Hourly Data Request',
            content: 'Unable to send your hourly data request',
            status: 'danger',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          return of(requestHourlyDataFailure('Error requesting hourly data'), displayToast(toastNotification));
        }),
      ),
    ),
  );
